import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import ButtonCancel from 'components/Buttons/ButtonCancel';
import MuiRegularButton from 'components/MuiExtras/Button/MuiRegularButton';
import MuiContainer from 'components/MuiExtras/MuiContainer';
import { WithSnackbar, withSnackbar } from 'components/SnackbarProvider/Snackbar';
import { GroupSuggestionDto } from 'models/ApiModels';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import GroupAutoComplete from 'views/Group/Components/GroupAutoComplete';

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

type JoinSelectedGroup = { id: string, name: string; };

interface IState {
    selected: GroupSuggestionDto[];
}

interface IProps {
    sourceGroupId: string;
    onClose: (selected: JoinSelectedGroup) => void;
}

type Props = IProps & WithSnackbar & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

class GroupJoinDialog extends React.Component<Props, IState> {

    constructor(props: Props) {
        super(props);
        this.state = {
            selected: [],
        };
    }

    ///
    private res(r: string, f: any = null) {
        return this.props.t("Views.Group.Components.GroupJoinDialog." + r, f);
    }

    ///
    public render() {
        const { onClose } = this.props;
        const { selected } = this.state;

        return (
            <Dialog
                open
                fullWidth
                onClose={() => { onClose(undefined); }}
                maxWidth="sm"
            >
                <DialogTitle>
                    {this.res("BoxTitle")}
                </DialogTitle>

                <DialogContent>
                    <MuiContainer >
                        <GroupAutoComplete
                            id="topicJoin"
                            autoFocus
                            overModal
                            placeholder={this.res("GroupPlaceholder")}
                            margin={"normal"}
                            selectedItems={selected}
                            multiple={false}
                            onChange={
                                (items) => {
                                    this.setState({ selected: items });
                                }
                            }
                            onValidate={
                                (item) => {
                                    const isValid = item.key != this.props.sourceGroupId;
                                    if (!isValid) this.props.snackbar.showMessage(this.res("InvalidGroupMessage"), "error");
                                    return isValid;
                                }

                            }
                        />
                    </MuiContainer>
                </DialogContent>
                <DialogActions>

                    <ButtonCancel
                        onClick={() => onClose(undefined)}
                    />

                    <MuiRegularButton
                        color="secondary"
                        onClick={() => onClose(selected.length == 0 ? null : { id: selected[0].key, name: selected[0].label })} >
                        <span>{this.props.t("Common.Buttons.SelectText")}</span>
                    </MuiRegularButton>
                </DialogActions>
            </Dialog>
        );
    }
}

export default withSnackbar(withTranslation()(GroupJoinDialog));